import React from "react";
import { Image } from '../../../ui';
import { getProductImageUrl } from '../../../library/helpers/product-image.js';
import styles from './production.module.scss';
import PropTypes from 'prop-types';
import SpecificationsDescription from "../specifications-description";
const ItemDeatilsSection = ({ detail , comment}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.product.main_photos?.[0] && <Image src={getProductImageUrl(detail.product.main_photos[0])}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>
                <SpecificationsDescription
                    specifications={detail.specification}
                    hiddenSpecifications={detail.item_hidden_specification}
                />
                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

ItemDeatilsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}
export default ItemDeatilsSection
